// extracted by mini-css-extract-plugin
export default {"container":"screenSharing_container__ZqSSZ","column":"screenSharing_column__i0FY5","screenSharing":"screenSharing_screenSharing__EJcls"};